/**
 * API Configuration
 * 
 * This file centrally manages all API endpoints and base URLs.
 * All API calls use the REACT_APP_BASE_URL environment variable.
 *
 * Local development: set REACT_APP_BASE_URL in react/.env
 * Cloudflare deployment: set REACT_APP_BASE_URL in the Cloudflare Pages environment
 */

const BASE_URL = process.env.REACT_APP_BASE_URL || "";

if (!BASE_URL) {
  console.warn("REACT_APP_BASE_URL is not defined. API requests may fail.");
}
// ============================================================================
// AUTH ENDPOINTS
// ============================================================================
export const API_ENDPOINTS = {
  // Authentication
  AUTH: {
    LOGIN: "auth/login/",
    LOGOUT: "auth/logout/",
    REFRESH: "auth/refresh/",
    VERIFY: "auth/verify/",
  },

  // Tenants
  TENANTS: {
    LIST: "tenants/tenants/",
    DETAIL: (id) => `tenants/tenants/${id}/`,
    CREATE: "tenants/tenants/",
    UPDATE: (id) => `tenants/tenants/${id}/`,
    DELETE: (id) => `tenants/tenants/${id}/`,
    MEMBERSHIPS: "tenants/tenant_memberships/",
    MEMBERSHIP_DETAIL: (id) => `tenants/tenant_memberships/${id}/`,
  },

  // Users
  ACCOUNTS: {
    USERS_LIST: "accounts/users/",
    USER_DETAIL: (id) => `accounts/users/${id}/`,
    CREATE_USER: "accounts/users/",
    UPDATE_USER: (id) => `accounts/users/${id}/`,
    DELETE_USER: (id) => `accounts/users/${id}/`,
  },

  // Modules
  MODULES: {
    LIST: "modules/modules/",
    DETAIL: (id) => `modules/modules/${id}/`,
    CREATE: "modules/modules/",
    UPDATE: (id) => `modules/modules/${id}/`,
    DELETE: (id) => `modules/modules/${id}/`,
  },

  // Dashboard
  DASHBOARD: {
    STATS: "dashboard/stats/",
    ACTIVITY: "dashboard/activity/",
  },

  // Tasks (Todo)
  TASKS: {
    LIST: "tasks/todos/",
    DETAIL: (id) => `tasks/todos/${id}/`,
    CREATE: "tasks/todos/",
    UPDATE: (id) => `tasks/todos/${id}/`,
    DELETE: (id) => `tasks/todos/${id}/`,
  },

  // Contacts
  CONTACTS: {
    LIST: "contacts/contacts/",
    DETAIL: (id) => `contacts/contacts/${id}/`,
    CREATE: "contacts/contacts/",
    UPDATE: (id) => `contacts/contacts/${id}/`,
    DELETE: (id) => `contacts/contacts/${id}/`,
  },

  // Invoices
  INVOICES: {
    LIST: "invoices/invoices/",
    DETAIL: (id) => `invoices/invoices/${id}/`,
    CREATE: "invoices/invoices/",
    UPDATE: (id) => `invoices/invoices/${id}/`,
    DELETE: (id) => `invoices/invoices/${id}/`,
  },

  // Calendar
  CALENDAR: {
    EVENTS: "calendar/events/",
    EVENT_DETAIL: (id) => `calendar/events/${id}/`,
  },

  // Chat
  CHAT: {
    MESSAGES: "chat/messages/",
    CONVERSATIONS: "chat/conversations/",
  },

  // Inbox
  INBOX: {
    MESSAGES: "inbox/messages/",
    FOLDERS: "inbox/folders/",
  },
};

/**
 * Get full endpoint URL
 * @param {string|function} endpoint - The endpoint from API_ENDPOINTS
 * @returns {string} - Full URL
 */
export const getApiUrl = (endpoint) => {
  if (typeof endpoint === "function") {
    return endpoint;
  }
  return `${BASE_URL}${endpoint}`;
};

/**
 * Get base API URL (for axios baseURL)
 * @returns {string} - Base URL with trailing slash
 */
export const getBaseUrl = () => {
  // Ensure trailing slash
  return BASE_URL.endsWith("/") ? BASE_URL : `${BASE_URL}/`;
};

export default API_ENDPOINTS;
